import deserialize from 'app/utils/deserialize'
import { fetch } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    iconRequests: []
  },

  mutations: {
    iconRequestsFetched(state, { iconRequests }) {
      state.iconRequests = iconRequests.map((i) => {
        i.isInProgress = i.labels.indexOf('in progress') >= 0
        return i
      })
    },

    resetState(state) {
      state.iconRequests = []
    }
  },

  getters: {
    iconRequests(state) {
      return state.iconRequests
    }
  },

  actions: {
    async fetchIconRequests({ commit }, { type }) {
      const response = await fetch({
        url: '/api/community/icon-requests',
        type: 'icon-requests',
        params: { type }
      })

      const iconRequests = await deserialize(response.data)

      commit('iconRequestsFetched', { iconRequests })

      return iconRequests
    }
  }
}
